import { connectedStore } from '../../store';
import selectors from '../selectors';

const getActivePageId = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getActivePageId(state);
};

export default getActivePageId;
